export default "__VITE_ASSET__CJdF9$B3__"